import { saveLocalStorage } from '../../../lib/tools';
import config from '../../../config';

const searchCriteria = config.localStorageKey.timeline;

// 検索条件をLocalStorageに保存
const saveSearchCriteria = (searchOptions, selectedTagIds) => {
  const {
    recordedDateFrom,
    recordedDateTo,
    partialOperatorName,
    partialDeviceNickname,
    freeTag,
    tags,
    isSearchForUnsetTagOnly,
    groupIds,
  } = searchOptions;
  saveLocalStorage(searchCriteria.recordedDateFrom, recordedDateFrom);
  saveLocalStorage(searchCriteria.recordedDateTo, recordedDateTo);
  saveLocalStorage(
    searchCriteria.partialOperatorName,
    partialOperatorName && encodeURIComponent(partialOperatorName),
  );
  saveLocalStorage(
    searchCriteria.partialDeviceNickname,
    partialDeviceNickname && encodeURIComponent(partialDeviceNickname),
  );
  saveLocalStorage(
    searchCriteria.freeTag,
    freeTag && encodeURIComponent(freeTag),
  );
  saveLocalStorage(searchCriteria.tags, tags && JSON.stringify(tags));
  saveLocalStorage(
    searchCriteria.selectedTagIds,
    selectedTagIds &&
      selectedTagIds.length !== 0 &&
      JSON.stringify(selectedTagIds),
  );
  saveLocalStorage(
    searchCriteria.isSearchForUnsetTagOnly,
    isSearchForUnsetTagOnly,
  );
  saveLocalStorage(
    searchCriteria.selectedGroupIds,
    groupIds && groupIds.length !== 0 && JSON.stringify(groupIds),
  );
};

export default saveSearchCriteria;
